import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProvincesDetailComponent } from './provinces-detail/provinces-detail.component';
import { ProvincesListComponent } from './provinces-list/provinces-list.component';

const routes: Routes = [
  { path: "provinces", component: ProvincesListComponent },
  { path: "provinces/:id", component: ProvincesDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProvincesRoutingModule { }
